import React from "react";

import Base from "../Base/Base";
import type { BaseProps } from "../../../../lib/modules/listSearchUtils/index.d";

export default function WithContentType(props: Readonly<BaseProps>) {
  const {
    contentTypeDisplayname
  } = props;

  return (
    <Base {...props}>
      { (contentTypeDisplayname) && <p className="text-neutral-subtle">{contentTypeDisplayname}</p> }
    </Base>
  );
}
